import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Es seguro comprar en esta página?',
    a: 'Sí, utilizamos pasarelas de pago seguras y encriptadas. Tus datos están protegidos en todo momento.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Una vez confirmado el pago, recibirás acceso inmediato al contenido digital para descargarlo o verlo online.'
  }, {
    q: '¿Puedo verlo desde mi celular?',
    a: 'Sí, todo el material está optimizado para ser leído cómodamente desde cualquier dispositivo: celular, tablet o computadora.'
  }, {
    q: '¿Este material garantiza que me borren del Clearing?',
    a: 'No. Este es un material estrictamente educativo e informativo. Te enseñamos cómo funciona el sistema y cuáles son tus derechos, pero no realizamos gestiones ni garantizamos resultados financieros.'
  }, {
    q: '¿Qué pasa si tengo dudas después de comprar?',
    a: 'Contamos con un equipo de soporte dispuesto a ayudarte con cualquier inconveniente técnico o duda sobre el acceso al material.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-surface" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-black text-slate-dark mb-4" data-id="element-135">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-136">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-137">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full text-left px-6 py-4 flex items-center justify-between focus:outline-none" data-id="element-138">
                <span className="font-bold text-slate-dark pr-4" data-id="element-139">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-green transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-140" />
              </button>
              <AnimatePresence data-id="element-141">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-142">
                    <div className="px-6 pb-4 text-slate leading-relaxed border-t border-gray-100 pt-4" data-id="element-143">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}